import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import FormBuilder from '@s-ui/react-form-builder'

import useFormVehicle from './useFormVehicle.js'

const BASE_CLASS_NAME = 'mt-FormC2bVehicle'
const NO_OP = () => {}

const FormC2bVehicle = ({
  makesList,
  onAutocompleteField = NO_OP,
  onClickSubmit,
  onFieldChange = NO_OP,
  onFormChange = NO_OP,
  onSubmitError = NO_OP,
  initialFieldValues
}) => {
  const {i18n} = useContext(Context)

  const {
    // config
    formConfiguration,
    initialValues,
    SUIComponentsConfig,
    // state
    isLoading,
    validatedErrors,
    // handlers
    handleOnBlur,
    handleOnChange,
    handleOnSubmit,
    requestInterceptorHandler,
    responseInterceptorHandler,
    setValidatedErrors
  } = useFormVehicle({
    makesList,
    onAutocompleteField,
    onClickSubmit,
    onFieldChange,
    onFormChange,
    onSubmitError,
    initialFieldValues
  })

  return (
    <div className={`${BASE_CLASS_NAME}Wrapper`}>
      <FormBuilder
        allowAutoFillOnInitLoad
        errors={validatedErrors}
        initFields={initialValues}
        json={formConfiguration}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        requestInterceptor={requestInterceptorHandler}
        responseInterceptor={responseInterceptorHandler}
        setErrors={setValidatedErrors}
      >
        {SUIComponentsConfig}
      </FormBuilder>
      <div className={`${BASE_CLASS_NAME}Button`}>
        <AtomButton
          isLoading={isLoading}
          fullWidth
          onClick={handleOnSubmit}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.LARGE}
        >
          {i18n.t('COMMON.CONTINUE')}
        </AtomButton>
      </div>
    </div>
  )
}

FormC2bVehicle.displayName = 'FormC2bVehicle'

FormC2bVehicle.propTypes = {
  makesList: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  onAutocompleteField: PropTypes.func,
  onClickSubmit: PropTypes.func,
  onFieldBlur: PropTypes.func,
  onFieldChange: PropTypes.func,
  onFormChange: PropTypes.func,
  onSubmitError: PropTypes.func,
  initialFieldValues: PropTypes.object
}

export default FormC2bVehicle
